<!-- 标签维护/账户维护弹窗 -->
<template>
    <div class="ml20">
        <span class="close-btn el-icon-close" @click="closeModal" v-if="!hideClose"></span>
        <div class="content-box mr60">
            <p class="mb20">{{desc}}</p>
            <div class="data-list font12px">
                <div v-for="(item,index) in list" :key="item.id">
                    <p>{{index+1}}、{{item.name}}(ID:{{item.id}})</p>
                        <span v-if="!isHideId">(ID:{{item.id}})</span>
                        <span v-if="item.package">({{item.package}})</span>
                    </p>
                    <div class="ml20" v-if="item.child&&item.child.length>0">
                        <p v-for="(inner,innerIndex) in item.child" :key="inner.id">
                            {{innerIndex+1}}、{{inner.name}}(ID:{{inner.id}})
                            <span v-if="inner.package">({{inner.package}})</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="closeModal" :disabled="countdown>0" class="action-btn mr20">{{cancelButtonText}} <span v-if="countdown>0">({{countdown}}s)</span></el-button>
            <el-button type="primary" @click="confirmModal" class="action-btn ml20">{{confirmButtonText}}</el-button>
        </p>
    </div>
</template>

<script>
    export default {
        name: "UndistributedTipModal",
        props:{
            cbs:Object,
            list:Array,
            desc:String,
            limit:[Number,String],
            hideClose:{
                type:Boolean,
                default:false,
            },
            tag:{
                type:String,
                default:'',
            },
            cancelButtonText:{
                type:String,
                default: '取消',
            },
            confirmButtonText:{
                type:String,
                default: '确定',
            },
        },
        data(){
            return {
                countdown:0,
            }
        },
        computed:{
            isHideId(){
                return this.tag=='account'||this.tag=='member';
            },
        },
        mounted(){
            let limit = this.limit;
            if(!isNaN(limit)){
                this.countdown = +limit;
                setTimeout(()=>{
                    this.startTimer();
                },1000)
            }
        },
        methods:{
            startTimer(){
                this.countdown--;
                if(this.countdown>0){
                    setTimeout(()=>{
                        this.startTimer();
                    },1000)
                }
            },
            confirmModal(){
                this.cbs.onConfirm({});
                this.$emit('close');
            },
            closeModal(){
                console.log('closeModal');
                this.cbs.onClose({});
                this.$emit('close');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .close-btn{
        display: block;
        position: absolute;
        right: 20px;
        top: 16px;
        cursor: pointer;
        font-size: 16px;
        &:hover{
            color: #00b3ee;
        }
    }

    .data-list{
        max-height: 400px;
        overflow-y: auto;
        padding-right: 20px;
    }
</style>
